import { FitnessClass } from "@/types/fitness-class";

/**
 * Helper function to safely extract capacity values from a FitnessClass
 */
export function getCapacityValues(cls: FitnessClass): {
  spotsLeft: number;
  capacity: number;
} {
  let spotsLeft = 0;
  let capacity = 0;

  if (typeof cls.spotsLeft === "object" && cls.spotsLeft !== null) {
    spotsLeft = (cls.spotsLeft as { enrolled?: number }).enrolled || 0;
  } else {
    spotsLeft = cls.spotsLeft || 0;
  }

  if (typeof cls.capacity === "object" && cls.capacity !== null) {
    capacity = (cls.capacity as { total?: number }).total || 0;
  } else {
    capacity = cls.capacity || 0;
  }

  return { spotsLeft, capacity };
}

/**
 * Helper function to extract price from pricing structure
 */
export function getPriceFromPricing(cls: FitnessClass): number {
  if (!cls.pricing) return 0;

  switch (cls.pricing.mode) {
    case "payPerSession":
      return cls.pricing.sessionPrice;
    case "classPack":
      return cls.pricing.totalPrice / cls.pricing.classesIncluded;
    case "subscription":
      return cls.pricing.totalPrice / cls.pricing.durationDays;
    case "course":
      return cls.pricing.totalPrice / cls.pricing.totalSessions;
    case "consultation":
      return cls.pricing.price;
    default:
      return 0;
  }
}

/**
 * Helper function to extract duration from schedule
 */
export function getDurationFromSchedule(cls: FitnessClass): number {
  if (!cls.schedule) return 0;
  return cls.schedule.durationMin || 0;
}

/**
 * Helper function to extract time from schedule
 */
export function getTimeFromSchedule(cls: FitnessClass): string {
  if (!cls.schedule) return "";

  switch (cls.schedule.kind) {
    case "single":
      return new Date(cls.schedule.date).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    case "recurring":
      return cls.schedule.startTime || "";
    case "course":
      if (cls.schedule.sessionDates.length > 0) {
        return new Date(cls.schedule.sessionDates[0]).toLocaleTimeString(
          "en-US",
          {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }
        );
      }
      return "";
    default:
      return "";
  }
}
